import {FC, useEffect, useMemo, useState} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {setSoItem, soSelector} from 'src/redux/slices/soSlices'
import {TIncontermCode} from 'src/utils/disableRouteByIncoterm'
import ReactSelect from 'react-select'
import { getIncoterm } from 'src/api/modules/getdatalist'

type TOption = {value: string; label: string}

interface Props {}

export const InputIncoterm: FC<Props> = () => {
  const {t} = useTranslation()
  const {soItem} = useAppSelector(soSelector)
  const dispatch = useAppDispatch()

  const [options, setOptions] = useState<TOption[]>([])
  const [incoterm, setIncoterm] = useState<TOption | null>(null)
  const [incoterm2, setIncoterm2] = useState<any>(null)

  const handleSelected = (option: TOption | null) => {
    setIncoterm(option)
    if (option) {
      const {value: incoterm, label: incoterm_desc} = option
      dispatch(setSoItem({...soItem, incoterm1: incoterm}))
    }
  }
  const handleChanged = (value: string) => {
    setIncoterm2(value)
    dispatch(setSoItem({...soItem, incoterm2: value}))
  }

  useEffect(() => {
    const handleFetchIncoterms = async () => {
      await getIncoterm()
        .then((res: any) => {
          let temparray: any[] = [{value: '', label: t('Pilih-incoterm')}]
          res.data.data.forEach((item: any) => {
            temparray.push({value: item.id, label: item.code})
          })
          setOptions(temparray)
          if(soItem?.incoterm1){
            setIncoterm(temparray.find((item: any) => item.label == soItem.incoterm1))
          }
        })
    }
    setIncoterm2(soItem?.incoterm2)

    handleFetchIncoterms()
  }, [])

  return (
    <>
      <Row className='mb-3'>
        <Col md={4}>
          <Form.Label className='mt-3'>Incoterm</Form.Label>
        </Col>
        <Col md={8}>
          {/* <Form.Control size='sm' aria-label='Default select example' value={incotermCode} disabled /> */}
          <ReactSelect
            placeholder={t('pilih')}
            value={incoterm}
            options={options}
            onChange={(option: any) => handleSelected(option)}
          />
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col md={4}>
          <Form.Label className='mt-3'>Incoterm 2</Form.Label>
        </Col>
        <Col md={8}>
          <Form.Control onChange={(e: any) => handleChanged(e.target?.value)} size='sm' aria-label='Default select example' value={incoterm2} />
          {/* <ReactSelect
            placeholder={t('pilih')}
            value={selected}
            options={options}
            onChange={(option: any) => handleSelected(option)}
          /> */}
        </Col>
      </Row>
    </>
  )
}
